import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute} from '@angular/router';
import {PAGE_SIZE_OPTIONS} from '@app/shared';
import {exportFileData} from '@shared/util/export-file';
import {CanhTacService} from '@entities/canh-tac/canh-tac.service';

@Component({
  selector: 'app-hoat-dong-canh-tac',
  templateUrl: './lich-su-qr-code.component.html',
})
export class LichSuQrCodeComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['fullName', 'qrcode', 'result', 'date'];
  ELEMENT_DATA = [];
  dataSource: any;
  totalItems: any;
  itemsPerPage: any;
  pageSizeOptions: number[];
  page = 1;
  noData: boolean;
  isLoading = true;
  config = {
    page: 0,
    size: 10,
  };
  payloadData = {
    crop_id: null,
  };
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  constructor(
    private activatedRoute: ActivatedRoute,
    private canhTacService: CanhTacService,
  ) {
    this.dataSource = new MatTableDataSource([]);
    this.pageSizeOptions = PAGE_SIZE_OPTIONS;
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.payloadData.crop_id = params.get('crop-id');
      this.loadAll();
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  loadAll() {
    this.isLoading = true;
    this.canhTacService
      .getHistoryScanQRCode(this.payloadData.crop_id)
      .subscribe((data) => {
        this.fillData(data.body);
        this.totalItems = data.body.length;
      });
  }

  fillData(data: any): void {
    this.isLoading = false;
    this.dataSource = new MatTableDataSource(data);
    this.noData = data.length === 0;
  }

  exportFile(): void {
    this.canhTacService
      .exportExcelQuery(this.payloadData.crop_id)
      .subscribe((res) => {
        exportFileData(res.body, res.headers);
      });
  }
}
